import { createError } from 'h3'

// Handle error wrapper to save lines of code.
export function handleError(status, message) {
  throw createError({
    statusCode: status,
    statusMessage: message,
  })
}

export function useZodValidationError(status, parsedBody) {
  const errorMessages = parsedBody.error.issues.map(issue => `${issue.path.join('.')}: ${issue.message}`).join(', ')
  handleError(400, errorMessages)
}

export function useZodValidatorErrorClient(parsedBody, life: number = 5000) {
  const $toast = useNuxtApp().$toast
  const $t = useNuxtApp()?.$i18n?.t

  const errorMessages = parsedBody.error.issues.map(issue => `${issue.path.join('.')}: ${issue.message}`).join(', ')

  $toast.add({
    severity: 'error',
    summary: $t('Validation error'),
    detail: errorMessages,
    life,
  })

  return errorMessages
}
